module.exports = __webpack_public_path__ + "img/vizualizace.99692682.svg";